// extracted by mini-css-extract-plugin
export default {"actions":"Ingresos_actions__bciWw","chip":"Ingresos_chip__xHtq+","link":"Ingresos_link__gO2pL"};